import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToScheduleCTA() {
  return <section id="readytoschedulecta" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-4xl rounded-2xl border border-border bg-card px-6 py-12 text-center shadow-sm sm:px-12 sm:py-16">
          <h2 className="font-default mb-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Ready to Schedule Your Appliance Repair?
          </h2>
          <p className="mx-auto mb-8 max-w-2xl text-lg text-muted-foreground">
            Get matched with an independent local trade pro in the Atlanta metro area. Submit your request or speak with our team.
          </p>
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="#bookingrequest">Request a Quote</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="tel:+14708479076">Call: (470) 847-9076</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}